module.exports = __webpack_public_path__ + "img/wheels.57e80585.jpg";